import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../infra/http/axios-http-client";
import { RemoteFetchCustomerTypes } from "../../data/usecases/remote-fetch-customer-types";
import { FetchCustomerTypes } from "../../domain/useages/fetch-customer-types";
import Endpoints from "../../domain/endpoints";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY,} from "../../base";
import { CustomerType } from "../../domain/models/customer-type";
import { getDataKeyFromLocalStorage } from "../../common/utils/AuthToken";

export interface FetchCustomerTypesInterface {
  customerTypesData: CustomerType[];
  fetchCustomerTypes: Function;
}

const initialStates = {
  customerTypesData: [],
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchCustomerTypesSlice: StateCreator<
  FetchCustomerTypesInterface
> = (set, get) => ({
  ...initialStates,
  fetchCustomerTypes: async () => {
     const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
     const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchCustomerTypes: FetchCustomerTypes =
      new RemoteFetchCustomerTypes(
        `${BASE_URL}${Endpoints.FETCH_CUSTOMER_TYPES}`,
        axiosHttpClient
      );

    let result = await remoteFetchCustomerTypes.fetch();
    if (result.success) {
      set(() => ({ customerTypesData: result.customerTypes }));
    }
  },
});
